<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :selectedQidSmall="selectedQidSmall"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        // title: '题目1',
        small: [
          {
            id: 1,
            title: '题目1',
            desc: [
              '1. 结合视频资料的信息，对照世界遗产考核标准，你认为都江堰被列入世界文化遗产名录的理由有哪些？',
              '<p style="text-indent: 0em;font-weight:bold">示例：</p>',
              '<p style="font-family: 楷体">标准V：代表一种人与环境相互作用的范例</p>',
              '<p style="font-family: 楷体">理由：都江堰工程能够依据水量季节变化，实现“四六分水”。既保证了冬春季节农田灌溉用水，又避免了夏秋季节洪水的发生，尊重了一年四季江水变化的自然规律。</p>',
              '<p style="font-family: 楷体">李冰父子用大竹笼装满卵石放在江心，形成鱼嘴。其取材源于自然，体现了人与自然和谐共存的水利思想。</p>'
            ],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '<b>都江堰的历史</b>'
              },
              {
                type: 'text',
                value: '世界遗产的评估标准是联合国教科文组织依据《保护世界文化和自然遗产公约》，对提名项目是否被列入《世界遗产名录》、成为世界遗产进行考核的标准。提名列入《世界遗产名录》的文化遗产项目，必须符合下列六项中的<span class="title_span">一</span><span class="title_span">项</span><span class="title_span">或</span><span class="title_span">几</span><span class="title_span">项</span>标准。 '
              },
              {
                type: 'img',
                isBig: true,
                value: require('@/assets/exam/26.png')
              },
              {
                type: 'text_abstract',
                noTextIndent: true,
                value: '【摘编自：联合国教育、科学及文化组织等《世界文化遗产评估标准》，《世界建筑》2019年第11期】'
              },
              {
                type: 'text',
                value: '2000年11月29日，都江堰被联合国列入世界文化遗产名录。观看以下视频素材。'
              }, {
                type: 'video',
                id: 1,
                value: [
                  {
                    autoPlay: false,
                    isControl: true,
                    isloop: false,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/54_63071fa5076a1/35ca4a060f7831a0bc26fa619436dde5.mp4'
                  }
                ]
              }
            ],
            showAnswer: false,
            askList: [{
              id: 1,
              type: 1,
              title: ''
            }]
          }
        ]
      }, {
        qid: 2,
        // title: '题目2',
        small: [
          {
            id: 2,
            title: '题目2',
            durationTime: 100,
            desc: ['2. 对于上述争论，你持何种观点？说说你的理由。'],
            hasDialog: true,
            stemContent: [
              {
                type: 'text',
                value: '<b>都江堰的发展</b>'
              },
              {
                type: 'text',
                value: '关于都江堰的发展规划，一直都存在着不同的声音。2003年，四川省水利水电勘测设计研究院，计划在距鱼嘴1310米的上游河道上，修建高约23米、宽1200米的杨柳湖大坝和带电站的水利枢纽工程。由于该工程距都江堰的核心区仅350米，规划一经提出，就引发了激烈的讨论。'
              },
              {
                type: 'img',
                isBig: true,
                value: require('@/assets/exam/29.png')
              },
            ],
            askList: [{
              id: 2,
              type: 1,
              isReview: true,
              title: ''
            }]
          },
          {
            id: 3,
            title: '题目3',
            durationTime: 100,
            desc: ['3. 依据资料1至5，你对刚刚自己的论证有何完善或者修正？'],
            stemContent: [
              {
                type: 'textArray',
                label: '资料1：都江堰主要工程变化大事年表',
                value: [
                  // { text: '都江堰主要工程变化大事年表' },
                  { img: require('@/assets/exam/17.png'), isBig: true }
                ]
              },
              {
                type: 'textArray',
                label: '资料2：江苏中学生现场考察都江堰报告（节选）',
                value: [
                  // { text: '江苏中学生现场考察都江堰报告（节选）' },
                  { text: '“今生”——都江堰已成摆设？', type: 'title' },
                  { text: '亲历实地，感受水利工程规模至恢宏的同时，我们也注意到了一个问题：内江汹涌，而外江却水量较小！细看是由于外江设置的机闸截断了江流，水流大都顺势流入内江。我们抵达的时节为7月，这应该是多雨的季节，却并没有看到都江堰“四六分水、二八分沙”的功能，都江堰中的飞沙堰除了排沙，还有调配水量的功能。能够在洪水期分流，在枯水期补给，保证成都平原得到源源不断的灌溉与滋润。然而，我们看到的却是飞沙堰干涸的泄洪通道还长着青草。毫不夸张地说，都江堰的历史功能已经“荡然无存”。' },
                  { text: '推敲其中原因，也不难理解。都江堰设计建造于两千年前，当时四川盆地人口尚少，相对于现在，用水量非常有限。如今四川盆地则有上亿人口，农业开发、工业建设和百姓生活都需要大量水资源。不断增长的水资源需求量促使人们千方百计进行“开源”引水，截流外江也就非常正常了。都江堰已在岁月的洗礼中，淡化了其“四六分水”的泄洪、引流功能和“二八分沙”的净水功能。这是否意味着随着时代发展，其已成摆设？正是这一问题引发了团队关于都江堰兴废的讨论。一个大胆的提议冒了出来：拆除都江堰，填平外江，引更多的水到四川盆地。' },
                  { text: '【摘编自：程怡伦等《思辨：都江堰该不该被拆掉》，《中学地理教学参考》2018年第3期】', type: 'abstract' },
                ]
              },
              {
                type: 'textArray',
                label: '资料3：成都市人口统计数据',
                value: [
                  // { text: '成都市人口统计数据' },
                  { text: '随着城镇化水平稳步提高，2020年成都常住人口较第六次全国人口普查增长38.5%,十年间年均增加58.2万人，人口规模位列全国第4;城镇人口由960.23万人增加到1649.30万人，城镇化率由63.5%提高到78.8%。' },
                  { img: require('@/assets/exam/18.png') },
                  { text: '[摘编自：《激昂奋进百年路领航征程著华章一一中国共产党成立100周年成都经济社会发展成就综述》（成都市统计局官网）]', type: 'abstract' },
                ]
              },
              {
                type: 'textArray',
                label: '资料4：都江堰灌区的水资源现状',
                value: [
                  // { text: '成都市人口统计数据' },
                  { text: '都江堰灌区水资源总量290亿m³。人均水资源量为1267m³,亩均水资源量1645m³,均低于全国及四川省人均水资源量。' },
                  { text: '据实测资料，都江堰的主水源——岷江来水量呈下降趋势，20世纪30年代年平均径流为174.1亿m³,2000〜2006年平均为133亿m³。' },
                  { text: '都江堰灌区年平均降雨量880mm〜1250mm。春季占15.6%〜17.7%。夏季占59.7%〜53.6%,秋季占22.0%〜24.8%,冬季占2.7%〜3.8%。年内分配极不均匀。岷江上游每年12月至次年5月来水量仅占全年的25%,3〜5月又恰好是灌区农业用水高峰期，与农作物正常需水常发生较大的矛盾。近年来，都江堰引水量在100亿m3左右，向灌区供水73亿m³。······由于来水量的时空分布不均，在用水高峰期，灌区年平均缺水量达到7亿m³,供需水矛盾十分突出。因此迫切需要建造杨柳湖水利工程，发挥其蓄水功能，保证灌区工农业生产用水量。' },
                  { text: '【摘编自：冯展《都江堰灌区存在的主要问题及其发展对策》，《四川水利》2008年第2期】', type: 'noTextIndent' },
                ]
              },
              {
                type: 'textArray',
                label: '资料5：国内新闻报道',
                value: [
                  // { text: '成都市人口统计数据' },
                  { text: '没有万分把握，不允许建任何工程', 'type': 'title' },
                  { text: '新华社成都8月4日电（记者张伟、侯大伟）近期，四川省水利部门提出，在都江堰鱼嘴上游1301米处修建高23米、长1200米的杨柳湖工程。杨柳湖工程的主要作用在于，缓和紫坪铺泄洪时，对都江堰鱼嘴的冲刷和破坏，同时作为紫坪铺的反调节水库，可以配合紫坪铺综合发挥防洪、灌溉、发电等效益。' },
                  { text: '由建设部、国家文物局、中国联合国教科文组织全委会、四川省建设厅、四川省文物局等单位的专家，组成了一个专项调查组。调查组认为，在都江堰上游建大坝，破坏了都江堰独有的无坝引水功能，有损都江堰作为世界文化遗产的真实性、惟一性原则。建设部王凤武认为，都江堰是“当今世界年代久远、惟一留存、以无坝引水为特征的宏大水利工程”，这一点是得到联合国认可的，不能遗产到手了，就忘记了都江堰作为世界遗产的定位。遗产给都江堰带来了巨大的知名度和经济社会效益，对都江堰的保护，怎么讲也不为过，不能有任何的破坏，没有万分的把握，不允许建任何工程。' },
                  { text: '【摘编自：张伟等《没有万分把握，不允许建任何工程》，《新华每日电讯》2003年08月05日】', type: 'abstract' },
                ]
              }
            ],
            askList: [{
              id: 2,
              type: 1,
              title: '',
              richText: true
            }]
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    async next(sonData, currentQSmall, type) {
      const data = Object.assign({
        exam_id: 1,
        exam_num: '1_' + currentQSmall,
        subject_id: 8,
        subject_name: '都江堰',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 3) {
        this.selectedQidSmall = 3
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'criticismSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
